import { Heading, Subheading, Paragraph } from 'components/src/typography';
import Button from 'components/src/button';
import { PackageSuggestionFormFieldFragment } from 'types/generated';
import PackageCard from '../PackageCard';
import { centeredMainGridClasses } from '@/styles/grid';
import { usePackageSuggestionContext } from './PackageSuggestionContext';
import { getSuggestionPackageId } from './Utils';
import { Source } from '@/analytics/segment';

type Props = {
  data: PackageSuggestionFormFieldFragment['packageSuggestionsCollection'];
  onStartAgainClick: () => void;
};

const SuggestionSection = ({ data, onStartAgainClick }: Props) => {
  const { state } = usePackageSuggestionContext();

  const numberOfAdults = Number(state.inputForms['veldu-fjolda-fullordna']);
  const numberOfChildrens = Number(state.inputForms['veldu-fjolda-barna']);
  const watchList = state.watchList;
  const packageId = getSuggestionPackageId(numberOfAdults, numberOfChildrens, watchList);
  const packageSuggestion = data?.items.find((x) => x?.id === packageId);

  return (
    packageSuggestion && (
      <div className={`${centeredMainGridClasses}`}>
        <div className="col-span-6 col-start-1 self-center lg:col-start-2">
          {packageSuggestion.subheading && (
            <Subheading classes="mb-8 text-white-100" small>
              {packageSuggestion.subheading}
            </Subheading>
          )}
          {packageSuggestion.title && (
            <Heading variant="small" classes="text-white-100">
              {packageSuggestion.title}
            </Heading>
          )}
          {packageSuggestion.description && (
            <Paragraph classes="mt-16 whitespace-break-spaces text-white-100">
              {packageSuggestion.description}
            </Paragraph>
          )}
          <div className="m-auto my-48 w-[304px] md:hidden">
            {packageSuggestion.packageCard && <PackageCard data={packageSuggestion.packageCard} />}
          </div>
          <Button
            label={'Byrja upp á nýtt'}
            variant={'primary'}
            classes="mt-24 w-full md:w-auto lg:mt-56"
            onClick={onStartAgainClick}
          />
        </div>
        <div className="hidden w-[304px] self-center md:col-start-8 md:grid lg:col-start-9">
          {packageSuggestion.packageCard && (
            <PackageCard data={packageSuggestion.packageCard} source={Source.PackageSuggestionForm} />
          )}
        </div>
      </div>
    )
  );
};
export default SuggestionSection;
